import React from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { Copy, Grid3x3, Square } from 'lucide-react';

export default function BatchControls({ 
  onApplyToAll, 
  hasTransforms, 
  viewMode, 
  onViewModeChange,
  badgeCount 
}) {
  return (
    <Card className="card-playful p-4 bg-card border-border/50">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <h4 className="text-sm font-semibold">Batch Controls</h4>
          {badgeCount > 1 && (
            <span className="text-xs text-muted-foreground">({badgeCount} badges)</span>
          )}
        </div>
        
        <div className="flex items-center gap-2">
          {/* View Mode Toggle */}
          <div className="flex items-center gap-1 p-1 bg-muted rounded-xl">
            <Button
              variant={viewMode === 'single' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('single')}
              className="rounded-lg h-8 px-3"
            >
              <Square className="w-3 h-3 mr-1" />
              Single
            </Button>
            <Button
              variant={viewMode === 'grid' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('grid')}
              className="rounded-lg h-8 px-3"
            >
              <Grid3x3 className="w-3 h-3 mr-1" />
              Grid
            </Button>
          </div>
          
          {/* Apply to All */}
          {hasTransforms && badgeCount > 1 && (
            <Button
              onClick={onApplyToAll}
              className="rounded-xl h-8 bg-gradient-to-r from-primary to-secondary hover:shadow-hover"
              size="sm"
            >
              <Copy className="w-3 h-3 mr-1" />
              Apply to All
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
